<template>
  <div :class="['d-flex', alignClass]">
    <v-btn
      v-bind="$attrs"
      v-on="$listeners"
      :class="[
        'button-widget px-14  text-none text-body-1 text-none grey--text text--lighten-1 rounded-0 elevation-0 text-h6 font-weight-bold ',
        secondary && 'grey--text text--darken-4 ',
      ]"
      :color="!secondary ? 'primary' : 'secondary'"
      height="52px"
    >
      <slot />
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    align: {
      type: String,
      default: "left",
      validator: (val) => ["left", "center", "right"].includes(val),
    },
    secondary: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    alignClass() {
      const classes = {
        left: "justify-start",
        center: "justify-center",
        right: "justify-end",
      };

      return classes[this.align];
    },
  },
};
</script>

<style>
.button-widget {
  box-shadow: 0px 4px 8px rgba(109, 78, 134, 0.25);
}
</style>
